<template>
	
	<article>
	    
	    <figure class="img img-sq">
		    <router-link :to="{ name: 'post', params: { postId: post.uid }}">
		    <prismic-image :field="post.data.featured_image" :alt="post.data.title"/>
	    	</router-link>
	    </figure>
	    
			<aside :class="$route.path === '/news' ? 'wrap wrap-half' : ''">
	    <div class="event-details"><div class="va "> 
				<!-- ^ class bt text-larger -->
        <!-- <span class="event-date text-extended">{{ labelFormat(post.data.date) }}</span> -->
        <!-- <br> -->
    
				<router-link :to="{ name: 'post', params: { postId: post.uid }}">
        	<h4 class="text-extended" style="margin-bottom: 20px;"><strong>{{ post.data.title }}</strong></h4>
					<span class="date text-uppercase text-condensed text-underline" style="margin-bottom: 16px;">{{ labelFormat(post.data.date) }}</span>
				</router-link>
        <prismic-rich-text :field="post.data.excerpt" class="text-smaller" style="hypens:none;"/>
        <router-link :to="{ name: 'post', params: { postId: post.uid }}" class="btn">
        	<span v-if="post.data.cta == null"><strong>Read More</strong></span>
        	<span v-else-if="post.data.cta != null"><strong>{{ post.data.cta }}</strong></span>        	
        </router-link>			
	  </div></div>
		</aside>
	</article>
	
</template>

<script>
import moment from 'moment'

export default {
  name: 'NewsPost',
  props: ['post'],
  data () {
    return {
    }
  },
	methods: {
		labelFormat(date) {
			var label = moment(date);
			label = label.format('ddd MMM D');
			return label;
		},
		timeFormat(datetime) {
			var label = moment(datetime);
			label = label.format('H:mma');
			return label;
		}
	},
	created () {
  }
}
</script>